import { initDynamicWidgets } from '../dynamic-plugins/load.js';

const imported = {};


// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	const { config } = mpro;

	// Init dynamic widgets
	initDynamicWidgets($container);

	// TODO: Move into delegates (there is no $container context)
	// Add facebook handling
	if (config.facebook.enabled && // Has side-effects
		!imported.fb) {
		imported.fb = true;
		import('./mpro.fb.js').then(({ fbInitializeLib }) => fbInitializeLib());
	}

	// TODO: Move into delegates (there is no $container context)
	// Enable ajax navigation
	if (config.ajax_navigation.enabled && // Has side-effects
		!imported.ajaxNavigation) {
		imported.ajaxNavigation = true;
		const { 'default': MpAjaxNavigation } = await import('../../remote/ajax-navigation/MpAjaxNavigation.js');
		new MpAjaxNavigation();
		// import('./mpro.ajaxify.js');
	}

	// Bulk edit tables
	/** @type {JQuery<HTMLSelectElement>} */
	// @ts-ignore
	const $bulkEditTables = $container.find('table[data-bulk-edit-table]');
	if ($bulkEditTables.length > 0) {
		import('./mpro.bulk-edit-table.js').then(({ enhanceBulkTables }) => enhanceBulkTables($bulkEditTables));
	}

	// Custom date-picker
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $dateInputs = $container.find('input[data-date-picker],div[data-date-picker],span[data-date-picker],a[data-date-picker],button[data-date-picker]');
	if ($dateInputs.length > 0) {
		import('./mpro.date-picker.js').then(({ enhanceElements }) => enhanceElements($dateInputs));
	}

	// Custom rating
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $ratingElements = $container.find('div[data-rating],span[data-rating]');
	if ($ratingElements.length > 0) {
		import('./mpro.rating.js').then(({ enhanceElements }) => enhanceElements($ratingElements));
	}

	// Custom selects (select2)
	/** @type {JQuery<HTMLSelectElement>} */
	// @ts-ignore
	const $customSelects = $container.find('select[data-custom-select]');
	if ($customSelects.length > 0) {
		import('./mpro.select2.js').then(({ enhanceSelects }) => enhanceSelects($customSelects));
	}

	// Google Maps Api
	/** @type {JQuery<HTMLElement>} */
	// @ts-ignore
	const $gMapsContainers = $container.find('div[data-google-maps-init], section[data-google-maps-init], span[data-google-maps-init]');
	if ($gMapsContainers.length > 0) {
		import('./mpro.gmaps.js').then(({ initMaps }) => initMaps($gMapsContainers));
	}

	// File upload fields
	const $simpleUploaders = $container.find('div[data-file-upload]');
	if ($simpleUploaders.length > 0) {
		import('./mpro.file-upload-simple.js').then(({ initFileUploadDecorator }) => initFileUploadDecorator($simpleUploaders));
	}

	// Find ajax-upload elements
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $ajaxUploadInputs = $container.find('input[data-ajax-upload]');
	if ($ajaxUploadInputs.length > 0) {
		import('./mpro.file-upload.js').then(({ initAjaxUploadDecorator }) => initAjaxUploadDecorator($ajaxUploadInputs));
	}

	// Find infinite scrolling elements
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $infiniteScrollingContainers = $container.find('[data-infinite-scrolling]');
	if ($infiniteScrollingContainers.length > 0) {
		import('./mpro.infinite-scrolling.js').then(({ handleLoadMoreRows }) => handleLoadMoreRows($infiniteScrollingContainers));
	}

	// ColorPicker widget
	/** @type {JQuery} */
	// @ts-ignore
	const $colorPickerInputs = $container.find('[data-color-picker]');
	if ($colorPickerInputs.length > 0) {
		import('./mpro.color-picker.js').then(({ colorPickerDecorator }) => colorPickerDecorator($colorPickerInputs));
	}

	// File Selector widget
	/** @type {JQuery} */
	// @ts-ignore
	const $fileSelector = $container.find('[data-file-picker]');
	if ($fileSelector.length > 0) {
		import('./mpro.file-picker.js').then(({ filePickerDecorator }) => filePickerDecorator($fileSelector));
	}

	// Autocomplete widget
	/** @type {JQuery} */
	// @ts-ignore
	const $autocompleteInputs = $container.find('input[data-autocomplete]');
	if ($autocompleteInputs.length > 0) {
		import('./autocomplete/init.js').then(({ jqDecorator }) => jqDecorator($autocompleteInputs));
	}
});

export default mpro;
